import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewStockInsumoHistorico = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'stock_insumo_historico',
        name: 'Stock Insumo Historico',
        component: ViewStockInsumoHistorico,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
